//derive the answered state of a call from its connection timestamps:
//connected -> answered, disconnected without connecting -> not answered, otherwise still ringing
export const getCallAnsweredState = (call) => {
  if (call?.connectedOn) return true;
  if (call?.disconnectedOn) return false;
  return null;
};
